import React, { Component } from 'react';
import $ from 'jquery';
import { json } from '../libs/utils/Const';


const noDesirePartnersFields = [
    'Sucursal',
    'Autoriza compra automáticament',
    'Bloquear cliente',
    'Venta crédito saldo vencido',
    'Método de pago',
    'Número de cuenta de pago',
    'Base de datos',
    'Addenda Retail One',
    'Factor de compra',
    'Número de lineas compra',
    'Addenda',
    'Configuración de Addenda',
    'Complemento',
    'Desglosa IEPS',
    'Juridico',
    'Tipo de Tercero (DIOT)',
]
const readOnlyPartnerFields = [8, 9, 10, 11, 18, 72, 75];
class UserFieldsPartnerModal extends Component {

    closeUserFields = async () => {
        $('#userFieldsPartnerModal').modal('hide');
    };

    closeAction = () => {
        $('#userFieldsPartnerModal').on('hiden.bs.modal', function () {
        });
    };

    changeUserFieldsDocument = (event, index) => {
        const { newOrderModel, refreshModel } = this.props;

        switch (index) {
            case 0:
                newOrderModel.userFields.userFields1 = event.nativeEvent.target.value;
                break;
            case 1:
                newOrderModel.userFields.userFields2 = event.nativeEvent.target.value;
                break;
            case 2:
                newOrderModel.userFields.userFields3 = event.nativeEvent.target.value;
                break;
            case 3:
                newOrderModel.userFields.userFields4 = event.nativeEvent.target.value;
                break;
            case 4:
                newOrderModel.userFields.userFields5 = event.nativeEvent.target.value;
                break;
            case 5:
                newOrderModel.userFields.userFields6 = event.nativeEvent.target.value;
                break;
            case 6:
                newOrderModel.userFields.userFields7 = event.nativeEvent.target.value;
                break;
            case 7:
                newOrderModel.userFields.userFields8 = event.nativeEvent.target.value;
                break;
            case 8:
                newOrderModel.userFields.userFields9 = event.nativeEvent.target.value;
                break;
            case 9:
                newOrderModel.userFields.userFields10 = event.nativeEvent.target.value;
                break;
            case 10:
                newOrderModel.userFields.userFields11 = event.nativeEvent.target.value;
                break;
            case 11:
                newOrderModel.userFields.userFields12 = event.nativeEvent.target.value;
                break;
            case 12:
                newOrderModel.userFields.userFields13 = event.nativeEvent.target.value;
                break;
            case 13:
                newOrderModel.userFields.userFields14 = event.nativeEvent.target.value;
                break;
            case 14:
                newOrderModel.userFields.userFields15 = event.nativeEvent.target.value;
                break;
            case 15:
                newOrderModel.userFields.userFields16 = event.nativeEvent.target.value;
                break;
            case 16:
                newOrderModel.userFields.userFields17 = event.nativeEvent.target.value;
                break;
            case 17:
                newOrderModel.userFields.userFields18 = event.nativeEvent.target.value;
                break;
            case 18:
                newOrderModel.userFields.userFields19 = event.nativeEvent.target.value;
                break;
            case 19:
                newOrderModel.userFields.userFields20 = event.nativeEvent.target.value;
                break;
            case 20:
                newOrderModel.userFields.userFields21 = event.nativeEvent.target.value;
                break;
            case 21:
                newOrderModel.userFields.userFields22 = event.nativeEvent.target.value;
                break;
            case 22:
                newOrderModel.userFields.userFields23 = event.nativeEvent.target.value;
                break;
            case 23:
                newOrderModel.userFields.userFields24 = event.nativeEvent.target.value;
                break;
            case 24:
                newOrderModel.userFields.userFields25 = event.nativeEvent.target.value;
                break;
            case 25:
                newOrderModel.userFields.userFields26 = event.nativeEvent.target.value;
                break;
            case 26:
                newOrderModel.userFields.userFields27 = event.nativeEvent.target.value;
                break;
            case 27:
                newOrderModel.userFields.userFields28 = event.nativeEvent.target.value;
                break;
            case 28:
                newOrderModel.userFields.userFields29 = event.nativeEvent.target.value;
                break;
            case 29:
                newOrderModel.userFields.userFields30 = event.nativeEvent.target.value;
                break;
            case 30:
                newOrderModel.userFields.userFields31 = event.nativeEvent.target.value;
                break;
            case 31:
                newOrderModel.userFields.userFields32 = event.nativeEvent.target.value;
                break;
            case 32:
                newOrderModel.userFields.userFields33 = event.nativeEvent.target.value;
                break;
            case 33:
                newOrderModel.userFields.userFields34 = event.nativeEvent.target.value;
                break;
            case 34:
                newOrderModel.userFields.userFields35 = event.nativeEvent.target.value;
                break;
            case 35:
                newOrderModel.userFields.userFields36 = event.nativeEvent.target.value;
                break;
            case 36:
                newOrderModel.userFields.userFields37 = event.nativeEvent.target.value;
                break;
            case 37:
                newOrderModel.userFields.userFields38 = event.nativeEvent.target.value;
                break;
            case 38:
                newOrderModel.userFields.userFields39 = event.nativeEvent.target.value;
                break;
            case 39:
                newOrderModel.userFields.userFields40 = event.nativeEvent.target.value;
                break;
            case 40:
                newOrderModel.userFields.userFields41 = event.nativeEvent.target.value;
                break;
            case 41:
                newOrderModel.userFields.userFields42 = event.nativeEvent.target.value;
                break;
            case 42:
                newOrderModel.userFields.userFields43 = event.nativeEvent.target.value;
                break;
            case 43:
                newOrderModel.userFields.userFields44 = event.nativeEvent.target.value;
                break;
            case 45:
                newOrderModel.userFields.userFields46 = event.nativeEvent.target.value;
                break;
            default:
                break
        }

        refreshModel(newOrderModel);
    };

    returnValue = index => {
        const { newOrderModel } = this.props;
        let value = "";
        switch (index) {
            case 0:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields1 : "";
                break;
            case 1:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields2 : "";
                break;
            case 2:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields3 : "";
                break;
            case 3:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields4 : "";
                break;
            case 4:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields5 : "";
                break;
            case 5:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields6 : "";
                break;
            case 6:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields7 : "";
                break;
            case 7:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields8 : "";
                break;
            case 8:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields9 : "";
                break;
            case 9:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields10 : "";
                break;
            case 10:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields11 : "";
                break;
            case 11:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields12 : "";
                break;
            case 12:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields13 : "";
                break;
            case 13:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields14 : "";
                break;
            case 14:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields15 : "";
                break;
            case 15:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields16 : "";
                break;
            case 16:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields17 : "";
                break;
            case 17:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields18 : "";
                break;
            case 18:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields19 : "";
                break;
            case 19:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields20 : "";
                break;
            case 20:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields21 : "";
                break;
            case 21:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields22 : "";
                break;
            case 22:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields23 : "";
                break;
            case 23:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields24 : "";
                break;
            case 24:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields25 : "";
                break;
            case 25:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields26 : "";
                break;
            case 26:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields27 : "";
                break;
            case 27:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields28 : "";
                break;
            case 28:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields29 : "";
                break;
            case 29:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields30 : "";
                break;
            case 30:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields31 : "";
                break;
            case 31:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields32 : "";
                break;
            case 32:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields33 : "";
                break;
            case 33:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields34 : "";
                break;
            case 34:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields35 : "";
                break;
            case 35:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields36 : "";
                break;
            case 36:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields37 : "";
                break;
            case 37:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields38 : "";
                break;
            case 38:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields39 : "";
                break;
            case 39:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields40 : "";
                break;
            case 40:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields41 : "";
                break;
            case 41:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields42 : "";
                break;
            case 42:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields43 : "";
                break;
            case 43:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields44 : "";
                break;
            case 45:
                value = newOrderModel.userFields ? newOrderModel.userFields.userFields46 : "";
                break;
            default:
                break
        }

        return value;
    }

    isReadOnlyField = (fieldId) => {
        const { view } = this.props;
        return view === 'bussinesPartner' && readOnlyPartnerFields.includes(fieldId);
    };

    renderFieldType1 = (json) => {
        const { action, editMode } = this.props;
        const isReadOnly = this.isReadOnlyField(json.fieldId);
        return (
            <tr>
                <td className="">
                    <label className="font-weight-bold" id='userField1'>{json.name}</label>
                </td>
                <td className="">
                    <input className="form-control" type="text" onChange={(event) => this.changeUserFieldsDocument(event, json.IdValue)}
                        disabled={isReadOnly || (action == 2 && !editMode)}
                        value={this.returnValue(json.IdValue)} />
                </td>
            </tr>
        )
    }

    renderFieldType2 = (json) => {
        const { action, editMode } = this.props;
        const isReadOnly = this.isReadOnlyField(json.fieldId);
        return (
            <tr>
                <td className="">
                    <label className="font-weight-bold" id='userField1'>{json.name}</label>
                </td>
                <td className="">
                    <select className="form-control" disabled={isReadOnly || (action == 2 && !editMode)} value={this.returnValue(json.IdValue)} onChange={(event) => this.changeUserFieldsDocument(event, json.IdValue)}>
                        {json.options.map(option => {
                            return (
                                <option value={option.FldValue}>{option.FldValue + ' - ' + option.Descr}</option>
                            )
                        })}
                    </select>
                </td>
            </tr>
        )
    }

    renderFieldType3 = (json) => {
        const { action, editMode } = this.props;
        let CreateTime = (this.returnValue(json.IdValue) || '').toString();

        if (CreateTime === '') {
            let fecha = new Date();
            CreateTime = fecha.getFullYear() + '-' + ((fecha.getMonth() + 1) < 10 ? '0' + (fecha.getMonth() + 1) : (fecha.getMonth() + 1)) + '-' + fecha.getDate();
        }

        return (
            <tr>
                <td className="">
                    <label className="font-weight-bold" id='userField1'>{json.name}</label>
                </td>
                <td className="">
                    <input className="form-control" type="date" onChange={(event) => this.changeUserFieldsDocument(event, json.IdValue)}
                        disabled={(action == 2 && !editMode) ? true : false}
                        max='9999-12-31'
                        value={CreateTime || ''} />
                </td>
            </tr>
        )
    }

    renderFieldType4 = (json) => {
        const { action, editMode } = this.props;
        let CreateTime = (this.returnValue(json.IdValue) || '').toString();

        if (CreateTime.length > 0) {
            let position = CreateTime.length - 2;
            CreateTime = CreateTime.slice(0, position) + ":" + CreateTime.slice(position, CreateTime.length)
        }
        return (
            <tr>
                <td className="">
                    <label className="font-weight-bold" id='userField1'>{json.name}</label>
                </td>
                <td className="">
                    <input className="form-control" type="time" onChange={(event) => this.changeUserFieldsDocument(event, json.IdValue)}
                        disabled={(action == 2 && !editMode) ? true : false}
                        value={CreateTime || ''} />
                </td>
            </tr>
        )
    }

    renderUserFieldsPartner = () => {
        return (
            <tbody>
                {json.userFieldsPartners.map((field) => {
                    const finded = noDesirePartnersFields.find((element) => element.name === field)
                    if (finded === undefined) {
                        if (field.fieldType === 1 && field.enabled) {
                            return this.renderFieldType1(field);
                        } else if (field.fieldType === 2 && field.enabled) {
                            return this.renderFieldType2(field);
                        } else if (field.fieldType === 3 && field.enabled) {
                            return this.renderFieldType3(field);
                        } else if (field.fieldType === 4 && field.enabled) {
                            return this.renderFieldType4(field);
                        }
                    }
                })}
            </tbody>
        )
    };

    renderUserFieldsPayment = () => {
        const { newOrderModel, action, editMode } = this.props;

        //console.log("dddddddddddddddddddddddddddddddddd",editMode, action);
        return (
            <tbody>

                {json.userFieldsPayment.map((field) => {
                    if (field.fieldType == 1 && field.enabled) {
                        return this.renderFieldType1(field);
                    } else if (field.fieldType == 2 && field.enabled) {
                        return this.renderFieldType2(field);
                    }
                })}

            </tbody>
        )
    }

    renderUserFields = () => {
        const { view } = this.props;

        let body = <tbody></tbody>;

        switch (view) {

            case 'payment':
                body = this.renderUserFieldsPayment();
                break;

            case 'bussinesPartner':
                body = this.renderUserFieldsPartner();
                break;

            default:
                break;
        }
        return body;
    };

    render() {
        const { newOrderModel, action, refreshModel, editMode, view } = this.props;
        //console.log("usefields-------------------------------------------------------", json, editMode, action, view);
        return (
            <div className="modal fade bd-example-modal-lg scroll bgtransparent" id="userFieldsPartnerModal"
                style={{ zIndex: 91 }} role="dialog" aria-labelledby="userFieldsPartnerModal" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-open " role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title ">Campos de Usuario</h4>
                            <button type="button" className="close" onClick={this.closeUserFields} aria-label="Close">
                                <span className="text-white" aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body" >
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div className="w-100 table-scroll tab-pane fade show active "
                                            aria-labelledby="nav-home-tab-Contenido"
                                            style={{ maxHeight: 560 }}>
                                            <table className="table response" style={{ marginBottom: 0 }}>
                                                <tr>
                                                    <td className="sticky-header table-header-yellow ">Nombre</td>
                                                    <td className="sticky-header table-header-yellow "
                                                        style={{ width: 250, textAlign: "center" }}> Valor
                                                    </td>
                                                </tr>
                                                {this.renderUserFields()}
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white"
                                onClick={this.closeUserFields}>Cerrar
                            </button>
                        </div>
                    </div>
                </div>
                {this.closeAction()}
            </div>
        );
    }
}

export default UserFieldsPartnerModal;